"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var messages_1 = __importDefault(require("./messages"));

exports.formatMessage = function (lang, id) {
  var message = messages_1.default[lang] && messages_1.default[lang][id] || messages_1.default[lang.split('-')[0]] && messages_1.default[lang.split('-')[0]][id] || messages_1.default['en'] && messages_1.default['en'][id] || 'MISSING (' + id + ', ' + lang + ')';
  return message;
};